module.exports = __webpack_public_path__ + "static/media/logo.3dd9fea6.png";